import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ja from '@/i18n/ja';
import vi from '@/i18n/vi';
import en from '@/i18n/en';
import id from '@/i18n/id';

/*
i18n のデフォルトのロケールの設定は
  src/pages/Root.vue
で行っている。
*/

Vue.use(VueI18n);
const i18n: VueI18n = new VueI18n({
  locale: 'ja',
  messages: { ja, vi, en, id }
});

export default i18n;
